import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/auth.service';

@Component({
  selector: 'app-forgot',
  templateUrl: 'forgot.component.html',
})
export class ForgotComponent {
  form: UntypedFormGroup;
  message: string;

  constructor(
    private fb: UntypedFormBuilder,
    public authService: AuthService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      email: ['', [Validators.email, Validators.required]],
    });
  }

  async submit() {
    this.message = '';

    try {
      await this.authService.forgot(this.form.controls.email.value);
      this.message = 'If the e-mail is in our database, you will get a link to recover your account';
    } catch (e) {
      this.message = 'A problem occurred, try again.';
    }
  }

  getValidationClass(field: string) {
    const control = this.form.controls[field];
    return {
      'is-valid': control.valid && (control.dirty || control.touched),
      'is-invalid': control.invalid && (control.dirty || control.touched),
    };
  }
}
